export default __webpack_public_path__ + "static/media/yahoo.b15bf6bc.svg";